(ns nl.mediquest.be-my-coach-frontend.subs
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::checked?
 (fn [db [_ k id]]
   (let [filter (get-in db [:filters k])]
     (boolean ((set (:selected filter)) id)))))

(re-frame/reg-sub
 ::example
 (fn [db]
   (:example db)))

(re-frame/reg-sub
 ::zorgverleners
 (fn [db]
   (:zorgverleners db)))

(re-frame/reg-sub
 ::highlighted-zorgverlener-id
 (fn [db]
   (:highlighted-zorgverlener-id db)))

(re-frame/reg-sub
 ::filters
 (fn [db]
   (:filters db)))

(re-frame/reg-sub
 ::filter-panel-open?
 (fn [db]
   (:filter-panel db)))
